import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { IonIcon, IonItemDivider, IonLabel, IonSegment, IonSegmentButton } from '@ionic/angular/standalone';
import { ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { AccountService } from '../../account';
import { DecaListComponent } from '../deca-list/deca-list.component';
import { IDecaListPeriod } from '../deca-store.model';

@Component({
  selector: 'lib-deca-list-selector',
  templateUrl: './deca-list-selector.component.html',
  styleUrls: ['./deca-list-selector.component.scss'],
  imports: [IonLabel, IonIcon, IonSegment, IonSegmentButton, IonItemDivider, DecaListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DecaListSelectorComponent {
  public readonly detailRoute = input.required<string>();

  // Emitted when the upcoming/past segment changes so the hosting page knows which
  // period is being viewed (used to scope user filters).
  public readonly segmentChange = output<IDecaListPeriod>();

  private readonly accountService = inject(AccountService);

  protected readonly activeSegment = signal<IDecaListPeriod>('upcoming');

  protected readonly canViewAsCarrier = computed(() =>
    this.accountService.hasCapability(ECapabilities.VIEW_DECA_AS_CARRIER),
  );
  protected readonly canViewAsShipper = computed(() =>
    this.accountService.hasCapability(ECapabilities.VIEW_DECA_AS_SHIPPER),
  );

  protected onSegmentChange(event: Event): void {
    const value = (event as CustomEvent).detail?.value;
    if (value === 'upcoming' || value === 'past') {
      this.activeSegment.set(value);
      this.segmentChange.emit(value);
    }
  }
}
